import deleteRequest from '../../../../../../deleteRequest';

/**
 * Bulk delete a multi attribute from multiple products.
 *
 * @param {{
 *  referenceIds: string[],
 *  productAttributeDefId: number,
 *  productAttributeLookupOptionId: number[],
 *  languageId: number,
 *  siteId: number,
 *  siteGroupId: number
 * }}
 * @param {string[]} referenceIds Product Ids
 * @param {number} productAttributeDefId Attribute Id
 * @param {number[]} productAttributeLookupOptionId Lookup Option Id
 * @param {number} sourceId Source Id - Example, 1 for Shogun
 * @param {number} languageId Language Id
 * @param {number} siteId Site Id
 * @param {number} siteGroupId Id of the Site Group
*/
export default async function deleteMultiSelectPluId({
  referenceIds,
  productAttributeDefId,
  productAttributeLookupOptionId,
  sourceId,
  siteId,
  languageId,
  siteGroupId,
}) {
  const endpoint = `/oc-product-bulkapi/v1/bulk-process/multi-selected-attributes/plu-id/${sourceId}`;

  const body = {
    referenceIds,
    productAttributeDefId,
    productAttributeLookupOptionId,
    siteId,
    languageId,
    siteGroupId,
  };

  const successMessage = 'Started : Multi Selected Attributes : PLU (Delete)';
  const errorMessageHeader = `Failed to DELETE - DefId: ${productAttributeDefId} - LookupOptionId: ${productAttributeLookupOptionId}`;

  return new Promise((resolve, reject) => {
    deleteRequest(endpoint, body, errorMessageHeader, successMessage)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
